import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { handleLocalStorage } from '../handleLocalStorage'
import { updateMomentLanguage } from '../updateMomentLanguage'

import de from './de/main.json'
import en from './en/main.json'
import fr from './fr/main.json'
import it from './it/main.json'

import es from './es-ES/main.json'
import pt from './pt-PT/main.json'
import ja from './ja/main.json'
import ar from './ar/main.json'
import zhCN from './zh-CN/main.json'
import ko from './ko/main.json'
import th from './th/main.json'
import zhHK from './zh-HK/main.json'

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it },

  es: { translation: es },
  pt: { translation: pt },
  ja: { translation: ja },
  ar: { translation: ar },
  zh: { translation: zhCN },

  ko: { translation: ko },
  th: { translation: th },
  'zh-HK': { translation: zhHK },
}

export type SupportedLanguage = keyof typeof resources

export const BUNDLED_LANGUAGES = Object.keys(resources) as SupportedLanguage[]

const bundledList = BUNDLED_LANGUAGES as readonly string[]

/** Match full BCP47 tag first, then primary subtag (e.g. zh-CN → zh, en-US → en). */
export function matchBundledLanguageTag(
  tag: string | undefined
): SupportedLanguage | undefined {
  if (!tag) return undefined
  let resolved: SupportedLanguage | undefined
  if (bundledList.includes(tag)) resolved = tag as SupportedLanguage
  else {
    const primary = tag.split('-')[0]
    if (bundledList.includes(primary)) resolved = primary as SupportedLanguage
  }
  return resolved
}

/** Default allowed list when /setup has no languagesConfig (persisted + Redux). */
export const DEFAULT_FALLBACK_ALLOWED_LANGUAGES: SupportedLanguage[] = [
  'de',
  'en',
  'fr',
  'it',
]

function getInitialLanguage(): SupportedLanguage {
  const fromStorage = handleLocalStorage('lang') as string | undefined
  const fromBrowser =
    typeof navigator !== 'undefined' ? navigator.language : undefined
  const candidate = fromStorage ?? fromBrowser
  return matchBundledLanguageTag(candidate) ?? 'de'
}

const initialLanguage = getInitialLanguage()

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
})

// moment's locale imports leave the GLOBAL locale at the last-imported one
// (Italian — QRM-614); the language middleware only fires on an explicit
// language switch, so the initial language must be synced here.
updateMomentLanguage(initialLanguage)

export default i18n
